module.exports = __webpack_public_path__ + "/img/Chip-Custom-Footprint-s40grS.svg";